/* eslint-disable no-plusplus */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, {
  Dispatch,
  ReactElement,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from 'react'

import { Button, Col, Form, Input, Row, Spin } from 'antd'
import { FormInstance } from 'antd/es/form/Form'
import { AxiosResponse } from 'axios'
import { SelectFieldAnt } from 'Components/Form'
import { SelectItemProps } from 'Components/Form/Select'
import ID_COMPONENTE from 'config/idComponente'
import { ApplicationContext } from 'Context'
import TipoArmazemEnum from 'Enumerations/TipoArmazemEnum'
import TipoCotaEnum from 'Enumerations/TipoCotaEnum'
import UsuarioGrupoTipoEnum from 'Enumerations/UsuarioGrupoTipoEnum'
import classificacaoHorarios from 'Helpers/classificacaoHorarios'
import usuarios from 'Helpers/usuarios'
import Veiculos from 'Helpers/Veiculos'
import Claims from 'Hooks/usePermissions/Claims'
import usePermissions from 'Hooks/usePermissions/usePermissions'
import { Empresa, Veiculo } from 'Models/cadastros'
import { ICandidato, IDoca, IHorario, IJanela } from 'Models/docas'
import IAgendamentoModoCompacto from 'Models/docas/IAgendamentoModoCompacto'
import IArmazemCota from 'Models/docas/IArmazemCota'
import ICotaBiomassa from 'Models/docas/ICotaBiomassa'
import IFormAgendamentoBiomassa from 'Models/docas/IFormAgendamentoBiomassa'
import IFormArmazemCotaFilter from 'Models/docas/IFormArmazemCotaFilter'
import IFormModoCompactoAdamiBiomassa from 'Models/docas/IFormModoCompactoAdamiBiomassa'
import { STATUS_HORARIOS } from 'Models/docas/IHorario'
import IVeiculoTransportadora from 'Models/docas/IVeiculoTransportadora'
import moment from 'moment'
import env from 'react-dotenv'
import { useForm } from 'react-hook-form'
import { useSnackbar } from 'react-simple-snackbar'
import { ParamsRequest } from 'Services/__shared/types/resquest'
import WsCadastroService from 'Services/WS_CADASTRO'
import WsDocasService from 'Services/WS_DOCAS'
import {
  ServiceCreateResponse,
  ServiceUpdateResponse,
} from 'Types/ServiceResponse'
import { MsgSuccessOptions } from 'Types/SnackbarTypes'
import IFormEmpresasFilter from 'Views/Cadastros/Empresas/IFormEmpresasFilter'

import { DocasContext } from './Context/context'

interface IProps {
  cdArmazem?: number
  cdArmazemConfig?: number
  cdArmazemTipo?: number
  agendamentos: IAgendamentoModoCompacto[]
  gerenciaCota?: boolean
  dataSelecionada?: moment.Moment
  agendamentoSelecionado?: IAgendamentoModoCompacto
  setAgendamentoSelecionado: Dispatch<
    SetStateAction<IAgendamentoModoCompacto | undefined>
  >
  atualizaAgenda: (
    limparSelecao?: boolean,
    executandoAcao?: boolean,
  ) => Promise<void>
}

const ModoCompactoAdamiBiomassa = ({
  cdArmazem,
  cdArmazemConfig,
  cdArmazemTipo,
  agendamentos,
  gerenciaCota,
  dataSelecionada,
  agendamentoSelecionado,
  setAgendamentoSelecionado,
  atualizaAgenda,
}: IProps): ReactElement => {
  const verificaCdsArmazensRegraEspecial = (): number[] => {
    const cdsArmazensRegraEspecial: string[] =
      env.CDS_AGENDAMENTO_DOCAS_ARMAZEM_REGRA_ESPECIAL.split(',')

    return cdsArmazensRegraEspecial.map((cdArmazemRegraEspecial: string) =>
      window.parseInt(cdArmazemRegraEspecial),
    )
  }

  const [cdsArmazensRegraEspecial] = useState<number[]>(
    verificaCdsArmazensRegraEspecial(),
  )
  const [regraEspecialAtiva, setRegraEspecialAtiva] = useState<boolean>(false)

  const hookForm = useForm()
  const [form] = Form.useForm()
  const { isAuthorized } = usePermissions()
  const { docasContext, setDocasContext } = useContext(DocasContext)
  const { applicationContext, setApplicationContext } =
    useContext(ApplicationContext)
  const [carregandoAgendaSimplificada, setCarregandoAgendaSimplificada] =
    useState<boolean>(false)
  const [
    carregandoCriacaoOuEdicaoAgendamento,
    setCarregandoCriacaoOuEdicaoAgendamento,
  ] = useState<boolean>(false)
  const [selectJanelaItens, setSelectJanelaItens] = useState<SelectItemProps[]>(
    [],
  )
  const [selectDocaItens, setSelectDocaItens] = useState<SelectItemProps[]>([])
  const [selectHorarioItens, setSelectHorarioItens] = useState<
    SelectItemProps[]
  >([])
  const [selectHorarioItensEdicao, setSelectHorarioItensEdicao] =
    useState<SelectItemProps[]>()

  const [selectTransportadoraItens, setSelectTransportadoraItens] = useState<
    SelectItemProps[]
  >([])

  const [horarios, setHorarios] = useState<IHorario[]>([])
  const [cdJanela, setCdJanela] = useState<number>()
  const [cdDoca, setCdDoca] = useState<number>()

  const [openSnackbarSuccess, closeSnackbarSuccess] =
    useSnackbar(MsgSuccessOptions)
  const [cdTransportadora, setCdTransportadora] = useState<number | undefined>()
  const [placa, setPlaca] = useState<string>()
  const [veiculo, setVeiculo] = useState<IVeiculoTransportadora>()
  const [criarVeiculo, setCriarVeiculo] = useState<boolean>(false)
  const [verificandoVeiculo, setVerificandoVeiculo] = useState<boolean>(false)
  const [criandoVeiculo, setCriandoVeiculo] = useState<boolean>(false)

  const [reservarAprovar, setReservarAprovar] = useState<boolean>(false)

  const [edicaoPreparada, setEdicaoPreparada] = useState<boolean>(false)

  const [docas, setDocas] = useState<IDoca[]>([])

  const [mostrarCampoTransportadora] = useState<boolean>(
    applicationContext.usuarioAtual?.cdsTransportadoras === undefined ||
      applicationContext.usuarioAtual.cdsTransportadoras.length > 1,
  )

  const limpaFormulario = (): void => {
    form.resetFields()
    setCdJanela(undefined)
    setCdDoca(undefined)
    setVeiculo(undefined)
    setPlaca(undefined)
    setSelectHorarioItensEdicao(undefined)
    setEdicaoPreparada(false)
  }

  const getTransportadorasBiomassa = async (): Promise<void> => {
    if (gerenciaCota && cdArmazem) {
      const filtros: IFormArmazemCotaFilter = { cdArmazem }
      //Regra explicada no bug 62169 do TFS
      // const filtros: IFormArmazemCotaFilter = {
      //   dtInicial: moment().subtract(7, 'days'),
      // }

      const { data } = await WsDocasService.armazemCota.buscaCotas(
        ID_COMPONENTE.DOCAS,
        filtros,
      )

      if (data.items) {
        let transportadorasBiomassa: IArmazemCota[] = data.items.filter(
          (transp) =>
            transp.cdAgendamentoDocasArmazemCotaTipo !== TipoCotaEnum.SemCota,
        )

        if (applicationContext.usuarioAtual?.cdsTransportadoras) {
          transportadorasBiomassa = transportadorasBiomassa.filter((transp) =>
            applicationContext.usuarioAtual!.cdsTransportadoras!.includes(
              transp.cdEntidade,
            ),
          )
        }

        const selectTransportadorasData: SelectItemProps[] =
          transportadorasBiomassa.map((item: IArmazemCota) => {
            return {
              value: item.cdEntidade.toString(),
              label: item.nome,
            }
          })

        setSelectTransportadoraItens(selectTransportadorasData)
      } else {
        setSelectTransportadoraItens([])
      }
    }
  }

  const getTransportadoras = async (): Promise<void> => {
    const filtros: IFormEmpresasFilter = {
      ativo: true,
    }

    const parametros: ParamsRequest = {
      pageSize: 10000,
      pageNumber: 1,
    }

    const { data } = await WsCadastroService.empresas.getList(
      ID_COMPONENTE.DOCAS,
      filtros,
      parametros,
    )

    if (data.items) {
      const selectTransportadorasData: SelectItemProps[] = data.items.map(
        (item: Empresa) => {
          return {
            value: item.id.toString(),
            label: item.nome,
          }
        },
      )

      setSelectTransportadoraItens(selectTransportadorasData)
    } else {
      setSelectTransportadoraItens([])
    }
  }

  const verificaSeDesabilitaDoca = (doca: IDoca): boolean => {
    if (applicationContext.usuarioAtual) {
      return (
        usuarios.verificaTipoGrupoUsuario(applicationContext.usuarioAtual) ===
          UsuarioGrupoTipoEnum.Transportadora &&
        regraEspecialAtiva &&
        doca.nomeDoca.toLowerCase() !== 'doca 1'
      )
    } else {
      return false
    }
  }

  const getAgendaSimplificada = async (): Promise<void> => {
    if (
      cdArmazem &&
      cdArmazemConfig &&
      cdArmazemTipo &&
      cdArmazemTipo === TipoArmazemEnum.Biomassa
    ) {
      setCarregandoAgendaSimplificada(true)

      const dataMinima: moment.Moment = moment()
      const horas: number = dataMinima.hours()
      const minutos: number = dataMinima.minutes()

      // dataMinima.set('hour', minutos > 0 ? horas + 2 : horas + 1)
      // dataMinima.set('minute', 0)
      dataMinima.set('hour', horas)
      dataMinima.set('minute', minutos)
      dataMinima.set('second', 0)
      dataMinima.set('millisecond', 0)

      const { data } = await WsDocasService.agenda.getAgendaSimplificada(
        ID_COMPONENTE.DOCAS,
        cdArmazemConfig,
        docasContext.dataAtual!.format('YYYY-MM-DD HH:mm:ss'),
      )

      if (data.item?.janelas && data.item.docas) {
        setDocas(data.item.docas)

        setSelectJanelaItens(
          data.item.janelas.map((janela: IJanela) => {
            let desabilitarJanela = false

            if (data.item!.janelas.length > 1) {
              const ultimoHorario = classificacaoHorarios.buscaUltimoHorario(
                janela.cdAgendamentoDocasJanela,
                data.item!.horarios,
              )

              desabilitarJanela = ultimoHorario.isBefore(dataMinima)
            }

            const janelaItem: SelectItemProps = {
              value: janela.cdAgendamentoDocasJanela.toString(),
              label: janela.nomeJanela,
              disabled: desabilitarJanela,
            }

            return janelaItem
          }),
        )

        setSelectDocaItens(
          data.item.docas.map((doca: IDoca) => {
            return {
              value: doca.cdAgendamentoDocasDocas.toString(),
              label: doca.nomeDoca,
              disabled: verificaSeDesabilitaDoca(doca),
            }
          }),
        )

        setHorarios(data.item.horarios)
      }

      if (cdJanela && cdDoca) {
        verificaHorariosDisponiveis()
      }

      setCarregandoAgendaSimplificada(false)
    }
  }

  const verificaLetra = (texto: string): boolean => {
    return /^[a-zA-Z]$/.test(texto)
  }

  const verificaNumero = (texto: string): boolean => {
    return !window.isNaN(+texto)
  }

  const verificaLetraOuNumero = (texto: string) => {
    return verificaLetra(texto) || verificaNumero(texto)
  }

  const verificaPlaca = (placa: string): boolean => {
    return (
      placa.length === 7 &&
      verificaLetra(placa[0]) &&
      verificaLetra(placa[1]) &&
      verificaLetra(placa[2]) &&
      verificaNumero(placa[3]) &&
      verificaLetraOuNumero(placa[4]) &&
      verificaNumero(placa[5]) &&
      verificaNumero(placa[6])
    )
  }

  const verificaVeiculo = async (): Promise<void> => {
    if (placa && verificaPlaca(placa)) {
      if (cdTransportadora) {
        setVerificandoVeiculo(true)

        const veiculo: IVeiculoTransportadora | undefined =
          await WsDocasService.veiculo.buscaVeiculo(
            ID_COMPONENTE.DOCAS,
            placa,
            cdTransportadora,
          )

        if (veiculo) {
          setVeiculo(veiculo)
        } else {
          setCriarVeiculo(true)
          openSnackbarSuccess(
            'O veículo informado ainda não está cadastrado para a sua transportadora. Clique no botão "Criar" para continuar',
          )
        }

        setVerificandoVeiculo(false)
      } else {
        openSnackbarSuccess('Selecione uma transportadora antes de continuar')
      }
    } else {
      openSnackbarSuccess(
        'A placa do veículo deve ter o formato ABC1234 ou ABC1D23',
      )
    }
  }

  const criaVeiculo = async (): Promise<void> => {
    if (placa && verificaPlaca(placa)) {
      if (cdTransportadora) {
        setCriandoVeiculo(true)

        const veiculo: IVeiculoTransportadora | undefined =
          await WsDocasService.veiculo.criaVeiculo(
            ID_COMPONENTE.DOCAS,
            placa,
            cdTransportadora,
          )

        if (veiculo) {
          setVeiculo(veiculo)
          openSnackbarSuccess('Veículo criado com sucesso')
        } else {
          openSnackbarSuccess(
            'Ocorreu um erro ao criar o veículo, favor contatar o suporte do Compulog',
          )
        }

        setCriarVeiculo(false)
        setCriandoVeiculo(false)
      } else {
        openSnackbarSuccess('Selecione uma transportadora antes de continuar')
      }
    } else {
      openSnackbarSuccess(
        'A placa do veículo deve ter o formato ABC1234 ou ABC1D23',
      )
    }
  }

  const criaOuEditaAgendamentos = async (
    dados: IFormModoCompactoAdamiBiomassa,
  ): Promise<void> => {
    if (veiculo) {
      setCarregandoCriacaoOuEdicaoAgendamento(true)

      const cdsHorarios: number[] = [window.parseInt(dados.cdHorario)]

      const agendamentos: IFormAgendamentoBiomassa[] = cdsHorarios.map(
        (cdHorario) => {
          return {
            cdCandidatoAgendamento: agendamentoSelecionado?.cdCandidato ?? 0,
            cdArmazem: cdArmazem!,
            cdAgendamentoDocasHorario: cdHorario,
            horarioStatus: reservarAprovar
              ? STATUS_HORARIOS.RESERVADO_APROVADO
              : STATUS_HORARIOS.RESERVADO,
            agendamentoMultiplo: cdsHorarios.length > 1,
            placaVeiculo: veiculo.placa!,
            cdTransportadora: veiculo.cdTransportadora!,
            cdVeiculo: veiculo.cdVeiculo!,
            observacao: dados.observacao,
          }
        },
      )

      const resposta: AxiosResponse<ServiceUpdateResponse> =
        agendamentoSelecionado
          ? await WsDocasService.armazemCota.editaAgendamentoBiomassa(
              ID_COMPONENTE.DOCAS,
              agendamentos,
            )
          : await WsDocasService.armazemCota.criaAgendamentoBiomassa(
              ID_COMPONENTE.DOCAS,
              agendamentos,
            )

      if (resposta.data.statusCode === 501) {
        await getAgendaSimplificada()
        await atualizaAgenda()

        setAgendamentoSelecionado(undefined)
        limpaFormulario()
      } else {
        openSnackbarSuccess(resposta.data.message)
      }

      setCarregandoCriacaoOuEdicaoAgendamento(false)
    } else {
      openSnackbarSuccess(
        'Preencha a placa do veículo e/ou clique no botão Verificar antes de continuar',
      )
    }
  }

  const verificaHorariosDisponiveis = (): void => {
    const camposParaLimpar: string[] = ['cdHorario']

    if (!cdDoca) {
      camposParaLimpar.push('cdDoca')
    }

    form.resetFields(camposParaLimpar)

    if (cdJanela && cdDoca) {
      const dataMinima: moment.Moment = moment()
      const horas: number = dataMinima.hours()
      const minutos: number = dataMinima.minutes()

      // dataMinima.set('hour', minutos > 0 ? horas + 2 : horas + 1)
      // dataMinima.set('minute', 0)

      dataMinima.set('hour', horas)
      dataMinima.set('minute', minutos)
      dataMinima.set('second', 0)
      dataMinima.set('millisecond', 0)

      const novosHorarios: SelectItemProps[] = horarios
        .filter(
          (horario) =>
            horario.cdAgendamentoDocasJanela === cdJanela &&
            horario.cdAgendamendoDocasDocas === cdDoca,
        )
        .map((horario: IHorario) => {
          return {
            value: horario.cdAgendamentoDocasHorario.toString(),
            label: horario.hora,
            disabled:
              moment(horario.dtHora, 'YYYY-MM-DDTHH:mm:ss') < dataMinima,
          }
        })

      if (selectHorarioItensEdicao) {
        setSelectHorarioItensEdicao(novosHorarios)
      } else {
        setSelectHorarioItens(novosHorarios)
      }
    }
  }

  const atualizaPlaca = (placa: string): void => {
    setPlaca(placa.toUpperCase())

    if (criarVeiculo) {
      setCriarVeiculo(false)
    }

    if (veiculo) {
      setVeiculo(undefined)
    }
  }

  const verificaPermissaoEditarDadosCompletos = (): boolean => {
    return isAuthorized(Claims.EditarDadosCompletosAgendamentoBiomassa)
  }

  const verificaPermissaoEditarDadosBasicos = (): boolean => {
    return (
      isAuthorized(Claims.EditarDadosBasicosAgendamentoBiomassa) ||
      verificaPermissaoEditarDadosCompletos()
    )
  }

  const verificaSeDesabilitaInput = (dadosBasicos: boolean): boolean => {
    let desabilitar: boolean = carregandoAgendaSimplificada

    if (!desabilitar && agendamentoSelecionado) {
      desabilitar = dadosBasicos
        ? !verificaPermissaoEditarDadosBasicos()
        : !verificaPermissaoEditarDadosCompletos()
    }

    return desabilitar
  }

  const iniciaPreparacaoEdicaoAgendamento = async (
    agendamento: IAgendamentoModoCompacto,
  ): Promise<void> => {
    let horariosEdicao: SelectItemProps[] = [...selectHorarioItens]

    horariosEdicao.push({
      value: agendamento.cdHorario.toString(),
      label: agendamento.horario,
    })

    //Ordena os horários de acordo com o label, que é o horário no formato "HH:mm"
    horariosEdicao = horariosEdicao.sort((h1, h2) =>
      h1.label < h2.label ? -1 : 1,
    )

    setSelectHorarioItensEdicao(horariosEdicao)

    await getTransportadorasBiomassa()
  }

  const finalizaPreparacaoEdicaoAgendamento = (
    agendamento: IAgendamentoModoCompacto,
  ): void => {
    setCdTransportadora(agendamento.cdTransportadora)
    setVeiculo({
      cdVeiculo: agendamento.cdVeiculo,
      placa: agendamento.placa,
      cdTransportadora: agendamento.cdTransportadora,
      transportadora: agendamento.nomeTransportadora,
    })

    form.setFieldsValue({
      cdJanela: agendamento.cdJanela.toString(),
      cdDoca: agendamento.cdDoca.toString(),
      cdHorario: agendamento.cdHorario.toString(),
      placa: agendamento.placa,
      cdTransportadora: agendamento.cdTransportadora.toString(),
      observacao: agendamento.observacaoCandidato,
    })

    setEdicaoPreparada(true)
  }

  const verificaDocasDisponiveisRegraEspecial = (): void => {
    if (regraEspecialAtiva) {
      setSelectDocaItens(
        docas.map((doca: IDoca) => {
          return {
            value: doca.cdAgendamentoDocasDocas.toString(),
            label: doca.nomeDoca,
            disabled: verificaSeDesabilitaDoca(doca),
          }
        }),
      )
    }
  }

  useEffect(() => {
    if (applicationContext.usuarioAtual?.cdsTransportadoras?.length === 1) {
      setCdTransportadora(applicationContext.usuarioAtual.cdsTransportadoras[0])
    }
  }, [])

  useEffect(() => {
    //gerenciaCota pode ser undefined, e nesse caso precisamos especificamente do valor false
    if (gerenciaCota === false) {
      getTransportadoras()
    }
  }, [gerenciaCota])

  useEffect(() => {
    setCdJanela(undefined)
    form.resetFields()
  }, [cdArmazem])

  useEffect(() => {
    if (cdArmazem) {
      setRegraEspecialAtiva(cdsArmazensRegraEspecial.includes(cdArmazem))
    }
  }, [cdArmazem, cdArmazemConfig, docasContext.dataAtual, agendamentos.length])

  useEffect(() => {
    if (agendamentoSelecionado) {
      setAgendamentoSelecionado(undefined)
    }
  }, [dataSelecionada, cdArmazem])

  useEffect(() => {
    getAgendaSimplificada()
  }, [regraEspecialAtiva])

  useEffect(() => {
    if (cdJanela || cdDoca) {
      verificaHorariosDisponiveis()
    } else if (selectHorarioItens.length > 0) {
      setSelectHorarioItens([])
    }
  }, [cdJanela, cdDoca])

  useEffect(() => {
    if (!cdJanela && selectJanelaItens.length === 1) {
      const cdJanela: string = selectJanelaItens[0].value
      form.setFieldsValue({ cdJanela })
      setCdJanela(window.parseInt(cdJanela))
    }
  }, [selectJanelaItens])

  useEffect(() => {
    limpaFormulario()

    if (agendamentoSelecionado) {
      setCdJanela(agendamentoSelecionado.cdJanela)
      setCdDoca(agendamentoSelecionado.cdDoca)
    }
  }, [agendamentoSelecionado])

  useEffect(() => {
    if (
      !edicaoPreparada &&
      agendamentoSelecionado &&
      selectHorarioItens.length > 0
    ) {
      iniciaPreparacaoEdicaoAgendamento(agendamentoSelecionado)
    }
  }, [selectHorarioItens])

  useEffect(() => {
    if (!edicaoPreparada && agendamentoSelecionado) {
      finalizaPreparacaoEdicaoAgendamento(agendamentoSelecionado)
    }
  }, [selectHorarioItensEdicao])

  return isAuthorized(Claims.ReservarHorario) ? (
    <>
      {regraEspecialAtiva && (
        <div style={{ textAlign: 'center', width: '100%', marginTop: '-10px' }}>
          Armazém com regra especial: transportadoras só podem realizar
          agendamentos na Doca 1
        </div>
      )}

      <Form
        form={form}
        onFinish={criaOuEditaAgendamentos}
        layout="vertical"
        style={{ width: '100%' }}
      >
        <Row gutter={16}>
          <Col span={8}>
            <SelectFieldAnt
              methods={hookForm}
              scope="form-modo-compacto"
              label="Janela:"
              name="cdJanela"
              items={selectJanelaItens}
              onChangeValue={(cdJanela: string) => {
                setCdJanela(window.parseInt(cdJanela))
                setCdDoca(undefined)
              }}
              showSearch={true}
              disabled={verificaSeDesabilitaInput(true)}
              rules={[{ required: true, message: 'Campo obrigatório' }]}
            />
          </Col>

          <Col span={8}>
            <SelectFieldAnt
              methods={hookForm}
              scope="form-modo-compacto"
              label="Doca:"
              name="cdDoca"
              items={selectDocaItens}
              onClick={() => verificaDocasDisponiveisRegraEspecial()}
              onChangeValue={(cdDoca: string) =>
                setCdDoca(window.parseInt(cdDoca))
              }
              showSearch={true}
              disabled={verificaSeDesabilitaInput(true)}
              rules={[{ required: true, message: 'Campo obrigatório' }]}
            />
          </Col>

          <Col span={8}>
            <SelectFieldAnt
              methods={hookForm}
              scope="form-modo-compacto"
              label="Horário:"
              name="cdHorario"
              items={selectHorarioItensEdicao ?? selectHorarioItens}
              showSearch={true}
              disabled={!cdJanela || !cdDoca || verificaSeDesabilitaInput(true)}
              rules={[{ required: true, message: 'Campo obrigatório' }]}
            />
          </Col>
        </Row>

        <Row gutter={16}>
          {mostrarCampoTransportadora && (
            <Col span={8}>
              <SelectFieldAnt
                methods={hookForm}
                scope="form-modo-compacto"
                label="Transportadora:"
                name="cdTransportadora"
                items={selectTransportadoraItens}
                showSearch={true}
                onClick={getTransportadorasBiomassa}
                onChangeValue={(value: string) => {
                  setPlaca(undefined)
                  setVeiculo(undefined)
                  form.resetFields(['placa'])
                  setCdTransportadora(window.parseInt(value))
                }}
                rules={[{ required: true, message: 'Campo obrigatório' }]}
                disabled={verificaSeDesabilitaInput(false)}
              />
            </Col>
          )}

          <Col span={8}>
            <Form.Item
              name="placa"
              label="Veículo:"
              rules={[{ required: true, message: 'Campo obrigatório' }]}
            >
              <Input
                maxLength={7}
                style={{ textTransform: 'uppercase' }}
                type="text"
                onChange={(e) => atualizaPlaca(e.target.value)}
                disabled={verificaSeDesabilitaInput(false)}
              />
            </Form.Item>
            {veiculo && <div>Transportadora: {veiculo.transportadora}</div>}
          </Col>

          <Col span={mostrarCampoTransportadora ? 8 : 16}>
            <Form.Item name="observacao" label="Observação Transportadora:">
              <Input type="text" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={24} style={{ textAlign: 'center' }}>
            <Button
              type="primary"
              onClick={() => verificaVeiculo()}
              disabled={placa?.length !== 7}
              loading={verificandoVeiculo}
            >
              Verificar
            </Button>

            <Button
              type="primary"
              style={{ marginLeft: '16px' }}
              onClick={() => criaVeiculo()}
              disabled={!criarVeiculo}
              loading={criandoVeiculo}
            >
              Criar
            </Button>

            {/* <Button
              type="primary"
              htmlType="submit"
              loading={carregandoCriacaoOuEdicaoAgendamento}
              style={{ marginTop: '30.5px', marginLeft: '16px' }}
            >
              Reservar
            </Button> */}

            {isAuthorized(Claims.ReservarAprovarHorario) && (
              <Button
                type="primary"
                htmlType="submit"
                loading={carregandoCriacaoOuEdicaoAgendamento}
                style={{ marginLeft: '16px' }}
                onClick={() => setReservarAprovar(true)}
              >
                Reservar e Aprovar
              </Button>
            )}

            {agendamentoSelecionado && (
              <Button
                type="primary"
                style={{ marginLeft: '16px' }}
                onClick={() => setAgendamentoSelecionado(undefined)}
                danger
              >
                Cancelar Edição
              </Button>
            )}
          </Col>
        </Row>
      </Form>
    </>
  ) : (
    <div style={{ color: 'red', marginBottom: '10px' }}>
      Você não tem permissão para reservar horários
    </div>
  )
}

export default ModoCompactoAdamiBiomassa
